/** Should match Figma. Imports nothing, so modules the theme imports (the status table) can use it without a cycle. */
export const colorSystem = {
    primary: {
        1: '#F5F8FF',
        2: '#E8EDFF',
        3: '#D9E0FF',
        4: '#B8C4FF',
        5: '#6E7EF7',
        6: '#5767EC',
        7: '#6166D1',
        8: '#4B54B0',
    },
    red: {
        1: '#FFF7F7',
        2: '#FDE8EC',
        3: '#FFD7DA',
        4: '#FFC2CA',
        5: '#FA6B7E',
        6: '#E85E6C',
        7: '#CD475D',
        8: '#9C3641',
        9: '#872F37',
    },
    yellow: {
        1: '#FFF8F0',
        2: '#FFF0DB',
        3: '#FFDDB7',
        4: '#FFCEA3',
        5: '#F9B686',
        6: '#F69D55',
        7: '#B76024',
        8: '#A54D12',
    },
    green: {
        1: '#F4FCF2',
        2: '#DDF8DD',
        3: '#C4EBC0',
        4: '#A5E3C4',
        5: '#02BE9E',
        6: '#0FA98F',
        7: '#2A847E',
        8: '#1B695B',
    },
    neutral: {
        white: '#FFFFFF',
        0: '#FCFCFD',
        1: '#F5F6FA',
        2: '#E9ECF4',
        3: '#D8DEEE',
        4: '#D1D5E0',
        5: '#B6BBC9',
        6: '#858CA0',
        7: '#676D7E',
        8: '#4C5366',
        9: '#2A3147',
    },
    blue: {
        1: '#F5FBFF',
        2: '#DBF1FF',
        3: '#CAE9FF',
        4: '#8CCBFF',
        5: '#599FFD',
        6: '#1871DC',
        7: '#3570B7',
        8: '#2D5F9B',
    },
    violet: {
        1: '#FDF8FE',
        2: '#F8E9FB',
        3: '#F0D3F6',
        4: '#E2B7F1',
        5: '#CE7EE9',
        6: '#AB4CCB',
        7: '#9F4CBB',
        8: '#7D3D8F',
    },
    teal: {
        1: '#F5FCFE',
        2: '#DFF5FB',
        3: '#C5EAF7',
        4: '#93D8EC',
        5: '#57C2E6',
        6: '#0BA3CB',
        7: '#047A97',
        8: '#04667E',
    },
};
